import { createStore } from "./createStore";
import type { AgentSession } from "../types";

export interface SessionsState {
  items: AgentSession[];
  activeId: string | null;
  loading: boolean;
  error: string | null;
}

export const sessionsStore = createStore<SessionsState>({
  items: [],
  activeId: null,
  loading: false,
  error: null,
});

export function setSessions(items: AgentSession[]) {
  sessionsStore.setState((current) => ({
    ...current,
    items,
    activeId:
      current.activeId && items.some((item) => item.id === current.activeId)
        ? current.activeId
        : (items[0]?.id ?? null),
    loading: false,
    error: null,
  }));
}
